<template>
  <div class="menu">
    <div @click="onLinkClick('review')" :class="activeCategory === 'review' ? 'link active' : 'link'">
      Краткий обзор функционала
    </div>
    <div @click="onLinkClick('estimates')" :class="activeCategory === 'estimates' ? 'link active' : 'link'">
      Наилучшие Оценки
    </div>
    <div @click="onLinkClick('rp')" :class="activeCategory === 'rp' ? 'link active' : 'link'">
      Рисковые Поправки (РП)
    </div>
    <div @click="onLinkClick('result-direct')" :class="activeCategory === 'result-direct' ? 'link active' : 'link'">
      Обзор Результата - Прямой бизнес
    </div>
    <div @click="onLinkClick('cashflows-direct')" :class="activeCategory === 'cashflows-direct' ? 'link active' : 'link'">
      Денежные Потоки (ДП) по прямому бизнесу
    </div>
    <div @click="onLinkClick('reinsurance')" :class="activeCategory === 'reinsurance' ? 'link active' : 'link'">
      Перестрахование
    </div>
    <div @click="onLinkClick('result-reinsurance')" :class="activeCategory === 'result-reinsurance' ? 'link active' : 'link'">
      Обзор результата – Перестрахование
    </div>
    <div @click="onLinkClick('cashflows-reinsurance')" :class="activeCategory === 'cashflows-reinsurance' ? 'link active' : 'link'">
      Денежные потоки (ДП) по исходящему бизнесу
    </div>
    <div @click="onLinkClick('cashflows-other')" :class="activeCategory === 'cashflows-other' ? 'link active' : 'link'">
      Прочие потоки
    </div>
    <div @click="onLinkClick('export')" :class="activeCategory === 'export' ? 'link active' : 'link'">
      Экспорт
    </div>
  </div>
</template>
  
<script>
export default {
  name: 'GuideMenu',
  props: {
    categoryTitle: String,
    activeCategory: String
  },
  methods: {
    onLinkClick(categoryTitle) {
      this.$emit('clicked', categoryTitle)
    }
  },
}
</script>

<style scoped>
.menu{
  display: flex;
  flex-direction: column;

  width: 20%;
  height: 100%;
  max-width: 20%;

  /* background-color: rgba(128, 128, 128, 0.295); */
}

.link{
  display: flex;
  justify-content: flex-start;
  align-items: center;
  background-color: #ffffff;

  color: black;
  font-weight: bold;
  font-size: 1rem;
  cursor: pointer;

  padding: 1rem;

  border: 1px solid #ebebf5;
}

.link.active{
  background-color: #3ebaff;
  color: white;
}
</style>
